import { useTranslation } from 'react-i18next';
import { Button } from '../../../web/src/components/interactive/button.jsx';
import { usePageTitle } from '../layout/use-page-title.js';
import { APP_URL } from '../app-config.js';

const ROWS = [
	{ key: 'profiles', note: true },
	{ key: 'spreadsheet', note: true },
	{ key: 'auditLog' },
	{ key: 'accounts' },
	{ key: 'api' },
	{ key: 'extension', note: true },
];

/**
 * Pricing page: the rough Free vs Premium plan, subject to change.
 * @returns {JSX.Element}
 */
export function PricingPage() {
	const { t } = useTranslation();
	usePageTitle('site.pricing.title', 'site.meta.pricing.description');

	return (
		<section className="pricing">
			<header className="pricing-hero">
				<h1>{t('site.pricing.title')}</h1>
				<p className="pricing-lede">{t('site.pricing.lede')}</p>
			</header>
			<div className="card">
				<div className="card-body">
					<table className="pricing-table">
						<thead>
							<tr>
								<th scope="col" />
								<th scope="col">{t('site.pricing.free')}</th>
								<th scope="col" className="pricing-premium-col">{t('site.pricing.premium')}</th>
							</tr>
						</thead>
						<tbody>
							{ROWS.map((row) => (
								<tr key={row.key}>
									<th scope="row" className="pricing-feature">
										{t(`site.pricing.row.${row.key}.label`)}
										{row.note && <span className="pricing-note">{t(`site.pricing.row.${row.key}.note`)}</span>}
									</th>
									<td>{t(`site.pricing.row.${row.key}.free`)}</td>
									<td className="pricing-premium-col">{t(`site.pricing.row.${row.key}.premium`)}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
			<p className="pricing-footnote">{t('site.pricing.footnote')}</p>
			<div className="pricing-actions">
				<Button as="a" href={APP_URL} target="_blank" variant="primary">{t('site.home.ctaPrimary')}</Button>
			</div>
		</section>
	);
}
